<div class="container-fluid bgcolor2">
    <form autocomplete="off" novalidate>
        <div class="row">
            <div class="col-sm-12 row align-items-center">
                <div
                    class=" card-header mt-2 mb-0 mb-0 example-full-width shadow-sm col-sm-12 card  text-black bgcolor ">
                    <div class='row pr-0 mr-0'>
                        <div class=" col-sm-2  ">
                            <mat-form-field appearance="outline" class="example-full-width" >
                                <mat-label> {{'header.branch-pattern-master.titleList.BranchCode' | translate }}
                                </mat-label> <input matInput>
                            </mat-form-field>
                        </div>
                        <div class=" col-sm-2  ">
                            <mat-form-field appearance="outline" class="example-full-width" >
                                <mat-label> {{'header.branch-pattern-master.titleList.BranchName' | translate }}
                                </mat-label> <input matInput>
                            </mat-form-field>
                        </div>
                        <div class=" col-sm-2  ">
                            <mat-form-field appearance="outline" class="example-full-width  " >
                                <mat-label> {{'header.branch-pattern-master.titleList.IsActive' | translate }}
                                </mat-label>
                                <mat-select required #select1
                                    placeholder=" {{'header.state-master.titleList.IsActive' | translate }}"
                                    class="colorblack">
                                    <mat-option value="abc"> abc</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class=" col-sm-2 mt-2"> <button type="button"
                                class=" btn btn-sm  example-full-width text-white"> {{
                                'header.branch-pattern-master.titleList.Save' | translate }} </button> </div>
                        <div class=" col-sm-2 mt-2"> <button type="button"
                                class=" btn btn-sm  example-full-width text-white"> {{
                                'header.branch-pattern-master.titleList.Back' | translate }} </button> </div>
                        <div class="col-sm-6 mt-2"></div>
                    </div>
                </div>
            </div>
            <div class="row col-sm-12">
                <div class="col-sm-12 pt-3">
                    <div class="example-container mat-elevation-z8">
                        <mat-table #table [dataSource]="dataSource" matSort>
                            <!-- Name Column -->
                            <ng-container matColumnDef="BranchCode">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> {{
                                    'header.branch-pattern-master.table.BranchCode' | translate }} </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.BranchCode}} </mat-cell>
                            </ng-container> <!-- Weight Column -->
                            <ng-container matColumnDef="BranchName">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> {{
                                    'header.branch-pattern-master.table.BranchName' | translate }}</mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.BranchName}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="Action">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> {{'header.town-master.table.Action'
                                    | translate }} </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.Action}} <i matTooltip="View"
                                        class="fas fa-eye"></i> </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                        </mat-table>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>